<template>
    <div id="app" >
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
    name: 'App',
    created () {
            // 在页面加载时读取sessionStorage里的状态信息
            if (sessionStorage.getItem("kd_client_store") ) {
                this.$store.replaceState(Object.assign({}, this.$store.state,JSON.parse(sessionStorage.getItem("kd_client_store"))))
            } 
            // 在页面刷新时将vuex里的信息保存到sessionStorage里
            window.addEventListener("beforeunload",()=>{    
                sessionStorage.setItem("kd_client_store",JSON.stringify(this.$store.state))
            })                                                                                      
        }
    }
</script>
<style>
    .el-divider>.el-divider__text{
      color: #5277F7;
      font-size: 23px;
    }
.el-page-header__left:hover{
          opacity: 0.7;
      }
      .el-page-header{
        position: fixed;
      }
.el-page-header__left{
      top: 20px;
      left: 20px; 
  }
.el-page-header__left>.el-icon-back{
    font-size: 20px;
    color: #5277F7;
}
.el-page-header__left>.el-page-header__title{
    font-size: 20px;
    color: #5277F7;
}   
</style>